define("shared/components/shared/ui/switcher/list", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropBody" data-qa-id={{@qaId}} ...attributes>
    <ul class="o--dropBody__list">
      {{#each @options as |option|}}
        {{yield option @select}}
      {{/each}}
    </ul>
  </div>
  */
  {
    "id": "BN/tEyii",
    "block": "[[[11,0],[24,0,\"o--dropBody\"],[16,\"data-qa-id\",[30,1]],[17,2],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,3]],null]],null],null,[[[1,\"      \"],[18,6,[[30,4],[30,5]]],[1,\"\\n\"]],[4]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@qaId\",\"&attrs\",\"@options\",\"option\",\"@select\",\"&default\"],false,[\"each\",\"-track-array\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/switcher/list.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});